import React from 'react';

import { getEntityDirectors } from 'common/api/helpers/Entity.helper';
import { PartialMovie } from 'common/components/ShowtimeModal/types';
import { IMAGE_EMPTY_PHOTO_PORTRAIT } from 'common/configuration/constants';
import { getImageUrl } from 'common/tools/network/url';
import trans from 'common/tools/translations/trans';

import styles from './styles.module.scss';

type MovieSummaryProps = {
  movie?: PartialMovie | null;
  movieRuntime: string | null;
};

const movieDetailsDurationLabel = trans('moviepage_movie_details.duration');
const movieDetailsDirectorLabel = trans('moviepage_movie_details.director');

const MovieSummary = ({ movie, movieRuntime }: MovieSummaryProps) => {
  const movieDirectors = getEntityDirectors(movie);

  const movie_img_src = getImageUrl({
    src: movie?.poster?.path || IMAGE_EMPTY_PHOTO_PORTRAIT,
    format: { rw: 64 }
  });

  return (
    <div className={styles.movieCover}>
      <img
        className={styles.moviePoster}
        src={movie_img_src}
        alt={movie?.title ?? undefined}
      />
      <div className={styles.movieInfo}>
        <div className={styles.movieTitle}>{movie?.title}</div>
        {!!movieDirectors?.length && (
          <div className={styles.movieDetail}>
            {`${movieDetailsDirectorLabel} `}
            <span>{movieDirectors.join(', ')}</span>
          </div>
        )}
        {movieRuntime && (
          <div className={styles.movieDetail}>
            {`${movieDetailsDurationLabel} `}
            <span>{movieRuntime}</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default MovieSummary;
